<template>
  <div class='sidebar-logo-container'>
    <transition name="sidebarLogoFade">
      <router-link class="sidebar-logo-link"
                   to="/">
        <template v-if="logoOptions.logoType=='all'">
          <img v-if="logoOptions.url"
               :src="logoOptions.url"
               class="sidebar-logo">
          <h1 class="sidebar-title">{{ logoOptions.title }} </h1>
        </template>
        <template v-if="logoOptions.logoType=='img'">
          <img v-if="logoOptions.url"
               :src="logoOptions.url"
               class="sidebar-logo">
        </template>
        <template v-if="logoOptions.logoType=='text'">
          <h1 class="sidebar-title">{{ logoOptions.title }} </h1>
        </template>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    logoOptions: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      // width: 32px;
      height: 38px;
      vertical-align: middle;
      margin-right: 12px;
      margin-left: 14px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }
}
</style>
